/**
 * Type constants for LinCal entities, modes, and actions
 * Centralizes all magic strings to prevent typos and enable IDE autocomplete
 */

// ============================================================================
// SIDEBAR TYPES AND MODES
// ============================================================================

/** Sidebar entity type being created/edited */
export const SIDEBAR_TYPE = {
  EVENT: 'event',
  MILESTONE: 'milestone'
};

/** Sidebar operation mode */
export const SIDEBAR_MODE = {
  CREATE: 'create',
  EDIT: 'edit'
};

// ============================================================================
// ENTITY TYPES (for drag data)
// ============================================================================

/** Entity type identifiers used in drag operations */
export const ENTITY_TYPE = {
  EVENT: 'event',
  MILESTONE: 'milestone'
};

// ============================================================================
// DRAG ACTIONS
// ============================================================================

/** Drag action types for events and milestones */
export const DRAG_ACTION = {
  MOVE: 'move',
  RESIZE_START: 'resize-start',
  RESIZE_END: 'resize-end'
};

// ============================================================================
// MILESTONE ICONS
// ============================================================================

/** Milestone icon identifiers */
export const MILESTONE_ICON = {
  FLAG: 'flag',
  DIAMOND: 'diamond',
  STAR: 'star',
  CIRCLE: 'circle'
};

/** Unicode characters for milestone icons */
export const MILESTONE_ICON_UNICODE = {
  [MILESTONE_ICON.FLAG]: '\u2691',      // ⚑
  [MILESTONE_ICON.DIAMOND]: '\u25C6',   // ◆
  [MILESTONE_ICON.STAR]: '\u2605',      // ★
  [MILESTONE_ICON.CIRCLE]: '\u25CF'     // ●
};

/** Icon options for dropdowns/selectors */
export const MILESTONE_ICON_OPTIONS = [
  { value: MILESTONE_ICON.FLAG, label: 'Flag', icon: MILESTONE_ICON_UNICODE[MILESTONE_ICON.FLAG] },
  { value: MILESTONE_ICON.DIAMOND, label: 'Diamond', icon: MILESTONE_ICON_UNICODE[MILESTONE_ICON.DIAMOND] },
  { value: MILESTONE_ICON.STAR, label: 'Star', icon: MILESTONE_ICON_UNICODE[MILESTONE_ICON.STAR] },
  { value: MILESTONE_ICON.CIRCLE, label: 'Circle', icon: MILESTONE_ICON_UNICODE[MILESTONE_ICON.CIRCLE] }
];

/** Default milestone icon */
export const DEFAULT_MILESTONE_ICON = MILESTONE_ICON.FLAG;

/**
 * Get the unicode character for a milestone icon
 * @param {string} iconId - Icon identifier (e.g., 'flag', 'diamond')
 * @returns {string} Unicode character for the icon
 */
export function getIconUnicode(iconId) {
  return MILESTONE_ICON_UNICODE[iconId] || MILESTONE_ICON_UNICODE[MILESTONE_ICON.FLAG];
}

// ============================================================================
// DATE PICKER STATES
// ============================================================================

/** Active date picker field */
export const DATE_PICKER_FIELD = {
  START: 'start',
  END: 'end',
  DATE: 'date'
};

// ============================================================================
// DIALOG VARIANTS
// ============================================================================

/** Dialog styling variants */
export const DIALOG_VARIANT = {
  DEFAULT: 'default',
  SUCCESS: 'success',
  ERROR: 'error',
  DANGER: 'danger'
};
